module.exports = __webpack_public_path__ + "img/Pell_添加.ec1894ed.svg";